import { ReactNode } from 'react';
import { ErrorIcon, InfoText, Wrapper } from './styled';

interface EmptyStateProps {
  height?: string;
  textColor?: string;
  src?: string;
  infoText?: string | ReactNode;
}

const EmptyState = ({
  height,
  textColor,
  src = 'icon/empty-state-outline.svg',
  infoText,
}: EmptyStateProps) => (
  <Wrapper height={height}>
    <ErrorIcon src={src} />
    <InfoText color={textColor}>{infoText}</InfoText>
  </Wrapper>
);

export default EmptyState;
